module.exports = __webpack_public_path__ + "static/media/history.84deaba5.svg";